// src/api/axiosInstance.js
import axios from 'axios';

let axiosInstance;

export const getAxiosInstance = () => {
    if (!axiosInstance) {
        axiosInstance = axios.create({
            baseURL: '/api',
            timeout: 20000,
            headers: { 'Content-Type': 'application/json' },
        });
    }
    return axiosInstance;
};

export const setupInterceptors = (getAccessTokenSilently) => {
    const instance = getAxiosInstance();

    if (instance.__interceptorsWired) return;
    instance.__interceptorsWired = true;

    instance.interceptors.request.use(
        async (config) => {
            try {
                const token = await getAccessTokenSilently();
                if (token) {
                    config.headers = config.headers || {};
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } catch (e) {
                console.warn('Silent token fetch failed before request:', e?.message);
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const { config, response } = error;
            if (!response) return Promise.reject(error); // network/timeout, etc.

            if (response.status === 401 && !config.__isRetryRequest) {
                config.__isRetryRequest = true;
                try {
                    const newToken = await getAccessTokenSilently();
                    if (newToken) {
                        config.headers = config.headers || {};
                        config.headers.Authorization = `Bearer ${newToken}`;
                        return instance(config);
                    }
                } catch (refreshErr) {
                    console.error('Token refresh on 401 failed:', refreshErr?.message);
                }
            }
            return Promise.reject(error);
        }
    );
};

export default getAxiosInstance;
